import { InputHTMLAttributes, memo, useState } from "react";
import styles from "../Input/Input.module.scss";
import eye_open from "../../../images/icons/eye_open.svg";
import eye_closed from "../../../images/icons/eye_closed.svg";

interface IInputProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  id: string;
  placeholder: string;
  value: string;
  setValue?: (value: string, id?: number) => void;
  errorMessage?: string | null;
  required?: boolean;
}

export const InputPassword = memo((props: IInputProps) => {
  const {
    label,
    value,
    setValue,
    id,
    placeholder,
    errorMessage,
    required = false,
    ...otherProps
  } = props;
  const [showPassword, setShowPassword] = useState(false);
  return (
    <div className={`${styles.group} ${errorMessage && styles.error}`}>
      <div className={styles.inputGroup}>
        <label htmlFor="email" className={styles.inputLabel}>
          {label}
          {required && <span className={styles.required}> *</span>}
        </label>
        <input
          type={showPassword ? "text" : "password"}
          id={id}
          name={id}
          placeholder={placeholder}
          value={value}
          onChange={(e) => setValue && setValue(e.target.value)}
          required={required}
          className={styles.inputField}
          {...otherProps}
        />
        <button
          type="button"
          className={styles.showPasswordBtn}
          onClick={() => setShowPassword(!showPassword)}
        >
          {showPassword ? (
            <img src={eye_open} alt="Hide password" />
          ) : (
            <img src={eye_closed} alt="Show password" />
          )}
        </button>
      </div>
      {errorMessage && <span className={styles.errorText}>{errorMessage}</span>}
    </div>
  );
});
